import { startEditProjectDraft } from "$src/application/projects/stores/projectStore";
import { autoTakeOverTimerValue, takeOverDialogVisible } from "$src/application/realtime/draftStore";
import { ServiceTokens } from "$src/domain/ServiceTokens";
import { EditStatus } from "$src/domain/core/EditStatus";
import { DraftPermission } from "$src/domain/projects/drafts/DraftPermission";
import type { IProjectDraftRepository } from "$src/domain/projects/drafts/IProjectDraftRepository";
import { inject, injectable } from "tsyringe";

@injectable()
export class RequestDraft {
    
    constructor(@inject(ServiceTokens.ProjectDraftRepository) private projectDraftRepository: IProjectDraftRepository) {}

    async execute(groupStoreId: number, projectId: number): Promise<DraftPermission> {

        var permission = await this.projectDraftRepository.RequestDraft(groupStoreId, projectId);

        switch(permission.status)
        {
            case EditStatus.Allowed:
                startEditProjectDraft(groupStoreId, permission.projectDraft);
                break;
            case EditStatus.InProgress:
                takeOverDialogVisible.set(true);
                autoTakeOverTimerValue.set(permission.takerOverDelayInSeconds);
                break;
        }

        return permission;
    }
}

export const RequestDraftToken = Symbol('RequestDraftToken');